import { Country, Currencies, InvoiceData, Statuses } from '@/types';
import { sql } from 'drizzle-orm';
import { integer, real, pgTable, date, text, json, serial, jsonb, boolean, timestamp } from 'drizzle-orm/pg-core';

export const invoices = pgTable('invoices', {
    invoiceNumber: text().notNull().unique().primaryKey(),
    customerId: integer().notNull(),
    contactId: integer().notNull(),
    status: text().$type<Statuses>().default("unpaid").notNull(),
    isArchived: boolean().notNull().default(false),
    publicToken: text(),
    privateToken: text(),
    invoiceData: json().$type<InvoiceData>().notNull(),
    lastModified: timestamp().notNull().default(sql`now()`),
});

export const customers = pgTable("customers", {
    id: serial().notNull().unique().primaryKey(),
    name: text().notNull(),
    address: text(),
    country: jsonb().$type<Country>().notNull(),
    status: text().$type<"active" | "archived">().default("active"),
});

export const contacts = pgTable("contacts", {
    id: serial().notNull().unique().primaryKey(),
    email: text().notNull(),
    phone: text(),
    firstName: text(),
    lastName: text(),
    customerId: integer().notNull(),
    status: text().$type<"active" | "archived">().default("active"),
})

export const transactions = pgTable("transactions", {
    id: serial().notNull().unique().primaryKey(),
    invoiceNumber: text().notNull(),
    amount: real().notNull(),
    currency: text().$type<Currencies>().notNull(),
    date: date({ mode: "date" }).notNull(),
});

export type SelectInvoice = typeof invoices.$inferSelect;
export type InsertInvoice = typeof invoices.$inferInsert;

export type SelectCustomer = typeof customers.$inferSelect;
export type InsertCustomer = typeof customers.$inferInsert;

export type SelectContact = typeof contacts.$inferSelect;
export type InsertContact = typeof contacts.$inferInsert;

export type CustomerWithContacts = SelectCustomer & {
    activeContacts: SelectContact[];
    archivedContacts: SelectContact[];

}
export type SelectTransaction = typeof transactions.$inferSelect;
export type Transaction = {
    date: string,
    invoice: SelectInvoice,
    customer: SelectCustomer
} & Omit<SelectTransaction, "date">;
export type InsertTransaction = typeof transactions.$inferInsert;
